import PropTypes from 'prop-types'
import styles from './Paginacion.module.css'

const MAX_PAGINAS_VISIBLES = 5
const PAGINAS_IZQUIERDA = 2

export const Paginacion = ({
  totalPaginas,
  paginaActual,
  onCambioPagina,
  itemsPorPagina,
  onCambioItemsPorPagina
}) => {
  const handleClick = (numPagina) => {
    if (numPagina !== paginaActual) {
      onCambioPagina(numPagina)
    }
  }

  const getPaginasVisibles = () => {
    let start = Math.max(1, paginaActual - Math.floor(MAX_PAGINAS_VISIBLES / PAGINAS_IZQUIERDA))

    let end = start + MAX_PAGINAS_VISIBLES - 1

    if (end > totalPaginas) {
      end = totalPaginas
      start = Math.max(1, end - MAX_PAGINAS_VISIBLES + 1)
    }

    return Array.from({ length: end - start + 1 }, (_, i) => start + i)
  }

  return (
    <div className={styles.paginacionContainer}>
      <div className={styles.paginacionCabecera}>
        <label className={styles.registrosPorPaginaLabel}>Registros por página:</label>
        <select
          value={itemsPorPagina}
          onChange={(e) => onCambioItemsPorPagina(Number(e.target.value))}
          className={styles.registrosPorPaginaSelect}
        >
          <option value={15}>15</option>
          <option value={30}>30</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
        </select>
      </div>
      <div>
        <button
          onClick={() => handleClick(paginaActual - 1)}
          disabled={paginaActual === 1}
          className={paginaActual === 1 ? styles.disabledBtn : styles.baseBtn}
          title="Página anterior"
        >
          <i className="fa fa-chevron-left" />
        </button>
        {getPaginasVisibles().map((num) => (
          <button
            key={num}
            onClick={() => handleClick(num)}
            className={num === paginaActual ? styles.activeBtn : styles.baseBtn}
          >
            {num}
          </button>
        ))}
        <button
          onClick={() => handleClick(paginaActual + 1)}
          disabled={paginaActual === totalPaginas}
          className={paginaActual === totalPaginas ? styles.disabledBtn : styles.baseBtn}
          title="Página siguiente"
        >
          <i className="fa fa-chevron-right" />
        </button>

        <button
          onClick={() => handleClick(totalPaginas)}
          disabled={paginaActual === totalPaginas}
          className={paginaActual === totalPaginas ? styles.disabledBtn : styles.baseBtn}
          title="Última página"
        >
          ⏭
        </button>
      </div>
    </div>
  )
}

Paginacion.propTypes = {
  totalPaginas: PropTypes.number.isRequired,
  paginaActual: PropTypes.number.isRequired,
  onCambioPagina: PropTypes.func.isRequired,
  itemsPorPagina: PropTypes.number.isRequired,
  onCambioItemsPorPagina: PropTypes.func.isRequired
}
